import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { GroupAddRounded } from '@mui/icons-material';

type ActionResponse = { id?: string; name?: string } | string | null;
type ActionArgs = { netProfileId?: string };

export type AndieCreateWorkspaceCompetitorProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieCreateWorkspaceCompetitor = (props: AndieCreateWorkspaceCompetitorProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.create-workspace-competitor.title')}
            icon={<GroupAddRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.create-workspace-competitor.loading')]}
            completeMessage={() => t('andie.tool.create-workspace-competitor.complete')}
            {...props}
        />
    );
};

export default AndieCreateWorkspaceCompetitor;
